// contexts/DesignContext.tsx
'use client';
import { createContext, useContext } from 'react';

export interface DesignSettings {
  colors: {
    primary: string;
    secondary: string;
    background: string;
    text: string;
    textLight: string;
    border: string;
  };
  typography: {
    headingFont: string;
    bodyFont: string;
    baseFontSize: string;
    headingWeights: Record<string, number>;
  };
  spacing: {
    containerMaxWidth: string;
    sectionPaddingTop: string;
    sectionPaddingBottom: string;
    gutter: string;
  };
  buttons: {
    primary: any;
    secondary: any;
    outline: any;
  };
  effects: {
    boxShadow: string;
    transition: string;
    borderRadius: string;
  };
}

const DesignContext = createContext<DesignSettings | null>(null);

export const DesignProvider = ({ children, design }: { children: React.ReactNode; design: DesignSettings }) => (
  <DesignContext.Provider value={design}>{children}</DesignContext.Provider>
);

export const useDesign = () => {
  const context = useContext(DesignContext);
  if (!context) throw new Error('useDesign must be used within DesignProvider');
  return context;
};